import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BuyButton } from "./BuyButton";

export const StickyBar = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 750);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-0 bottom-0 z-50 border-t border-navy/10 bg-white/85 backdrop-blur-xl"
          data-testid="sticky-purchase-bar"
        >
          <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-6 py-3.5 lg:px-10">
            <div className="min-w-0">
              <p className="truncate font-display text-sm font-bold tracking-tight text-navy sm:text-base">
                Building a Speak-Up Culture™ Toolkit
              </p>
              <p className="text-xs text-navy/55 sm:text-sm">
                <span className="font-bold text-terra">$249</span> one-time · unlimited reuse
              </p>
            </div>
            <BuyButton testId="sticky-bar-buy-button" size="sm" className="shrink-0">Get It Now</BuyButton>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
